import { render, staticRenderFns } from "./IssueButton.vue?vue&type=template&id=6e36878d&scoped=true&"
import script from "./IssueButton.vue?vue&type=script&lang=js&"
export * from "./IssueButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e36878d",
  null
  
)

export default component.exports